import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { IcustomerService } from '../icustomer.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Union, UserType, Gender, Taluk, District, State, RelationType } from '../../agent/agent-interface.service';
import { GlobalValidationService } from '../../global-validation.service'
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalService } from 'src/app/global.service';
import { ThemePalette } from '@angular/material';
@Component({
  selector: 'app-icustomer-register',
  templateUrl: './icustomer-register.component.html',
  styleUrls: ['./icustomer-register.component.scss']
})
export class IcustomerRegisterComponent implements OnInit {
  action: string = '';
  icustomer_register_form: FormGroup;
  unions: Union[] = [];
  user_types: UserType[] = [];
  genders: Gender[] = [];
  taluks: Taluk[] = [];
  districts: District[] = [];
  states: State[] = [];
  customer_types: CustomerType[] = [];
  business_list: BusinessList[] = [];
  image: any = null;
  products: any;
  register_on_process = false;
  color: ThemePalette = 'primary';
  value = 50;
  customer_type_id: any = null;
  icustomer_union_dict: any;
  showProductField = false;
  showExEmployeeUnionField = false;
  constructor(private formBuilder: FormBuilder, private icustomerService: IcustomerService, private http: HttpService, private sanitizer: DomSanitizer, private global: GlobalService) {
    // this.getCvData();
    this.getDistricts();
    this.getUserTypes();
    this.getGender();
    this.getUnion();
    this.getTaluk();
    this.getState();
    this.getcustomerType();
    this.getBusiness();
    this.getproducts();
    this.getExemployeeUnion();
    this.icustomer_register_form = this.formBuilder.group({
      id: [null],
      first_name: [null, Validators.compose([Validators.required])],
      last_name: [null, Validators.compose([Validators.required])],
      union_id: [1, Validators.compose([Validators.required])],
      gender_id: [null, Validators.compose([Validators.required])],
      street: [null],
      taluk_id: [null, Validators.compose([Validators.required])],
      district_id: [null, Validators.compose([Validators.required])],
      state_id: [1, Validators.compose([Validators.required])],
      pincode: [null, Validators.compose([GlobalValidationService.checkPincode])],
      mobile: [null, Validators.compose([GlobalValidationService.checkMobileNumber, Validators.required])],
      alternate_mobile: [null, Validators.compose([GlobalValidationService.checkMobileNumber])],
      customer_type_id: [null, Validators.compose([Validators.required])],
      business_id: [null, Validators.compose([Validators.required])],
      aadhar_number: [null, Validators.compose([GlobalValidationService.checkAadharNumber])],
      icustomer_image: [null],
      product_id: [null],
      union_for_icustomer_id: [null]
    });

    if (this.icustomerService.get_icustomer_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.icustomerService.get_icustomer_data);
      // if (this.icustomerService.get_icustomer_data['customer_type_id'] != '3') {
      //   this.customer_type_id = this.icustomerService.get_icustomer_data['customer_type_id']
      //   this.icustomer_register_form.get('customer_type_id').disable();

      // }
    }

    this.icustomerService.icustomerUpdate.subscribe((icusotmer) => {
      if (icusotmer === null) {
        this.action = 'register';
        this.icustomer_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(icusotmer);
      }
    });

    this.icustomerService.icustomerUpdate.subscribe((icusotmer_data) => {
      this.setupUpdateForm(icusotmer_data);
    });


  }


  //setupupdateform
  setupUpdateForm(element) {
    console.log(element)
    this.http.getIcustomerDetails(element).subscribe((data) => {
      console.info(data);
      this.icustomer_register_form.controls['id'].setValue(data['id']);
      this.icustomer_register_form.controls['first_name'].setValue(data['first_name']);
      this.icustomer_register_form.controls['last_name'].setValue(data['last_name']);
      this.icustomer_register_form.controls['union_id'].setValue(data['union_id']);
      this.icustomer_register_form.controls['gender_id'].setValue(data['gender_id']);
      this.icustomer_register_form.controls['street'].setValue(data['street']);
      this.icustomer_register_form.controls['taluk_id'].setValue(data['taluk_id']);
      this.icustomer_register_form.controls['district_id'].setValue(data['district_id']);
      this.icustomer_register_form.controls['state_id'].setValue(data['state_id']);
      this.icustomer_register_form.controls['pincode'].setValue(data['pincode']);
      this.icustomer_register_form.controls['mobile'].setValue(data['mobile']);
      this.icustomer_register_form.controls['alternate_mobile'].setValue(data['alternate_mobile']);
      this.icustomer_register_form.controls['business_id'].setValue(data['business_id']);
      this.icustomer_register_form.controls['customer_type_id'].setValue(data['customer_type_id']);
      this.icustomer_register_form.controls['aadhar_number'].setValue(data['aadhar_number']);
      this.icustomer_register_form.controls['product_id'].setValue(data['product_id']);
      this.icustomer_register_form.controls['union_for_icustomer_id'].setValue(data['union_for_icustomer']);
      if (data.hasOwnProperty('image')) {
        this.image = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + data['image']);
      }
    })
  }
  getproducts() {
    this.http.getMilkProduct().subscribe((data) => {
      console.info(data);
      this.products = data;
    })
    console.log()
  }

  toBase64(event) {
    console.log(event);
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = (e) => {
      console.log(reader.result);
      this.image = reader.result;
      console.log(this.image);
    };
    console.log(reader.readAsDataURL(file));
  }

  getCvData() {
    this.getDistricts();
    this.getUserTypes();
    this.getGender();
    this.getUnion();
    this.getTaluk();
    this.getState();
    this.getcustomerType();
    this.getBusiness();
  }

  getDistricts() {
    this.http.getDistrict().subscribe((data: District[]) => {
      console.log(data);
      this.districts = data;
    }, (error) => {
      console.log(error);
    });
  }


  getUnion() {
    this.http.getUnions().subscribe((data: Union[]) => {
      console.log(data);
      this.unions = data;
    }, (error) => {
      console.log(error);
    });
  }


  getUserTypes() {
    this.http.getUserTypes().subscribe((data: UserType[]) => {
      console.log(data);
      this.user_types = data;
    }, (error) => {
      console.log(error);
    });
  }

  getGender() {
    this.http.getGenders().subscribe((data: Union[]) => {
      console.log(data);
      this.genders = data;
    }, (error) => {
      console.log(error);
    });
  }

  getTaluk() {
    this.http.getTaluks().subscribe((data: Taluk[]) => {
      console.log(data);
      this.taluks = data;
    }, (error) => {
      console.log(error);
    });
  }

  getState() {
    this.http.getStates().subscribe((data: State[]) => {
      console.log(data);
      this.states = data;
    }, (error) => {
      console.log(error);
    });
  }

  getcustomerType() {
    this.http.getCustomerType().subscribe((data: State[]) => {
      console.info(data);
      this.customer_types = data;
    }, (error) => {
      console.log(error);
    });
  }

  getBusiness() {
    this.http.getBooths().subscribe((data: State[]) => {
      console.log(data);
      this.business_list = data;
    }, (error) => {
      console.log(error);
    });
  }

  registerIcustomer() {
    this.register_on_process = true;
    let icustomer_data = Object.assign({}, this.icustomer_register_form.value);
    console.log(icustomer_data)
    if (this.customer_type_id != null) {
      icustomer_data['customer_type_id'] = this.customer_type_id;
    }
    if (this.image != null) {
      icustomer_data['icustomer_image'] = this.image;
    }
    console.log(icustomer_data)
    this.http.registerIcustomer(icustomer_data).subscribe((data) => {
      this.icustomer_register_form.reset();
      this.image = null;
      this.global.showSnakeBar(data['message']);
      this.icustomerService.is_icustomer_register_component = false;
      this.icustomerService.downloadIcustomer.emit(true);
      this.register_on_process = false;
    }, (error) => {
      // this.global.showSnakeBar(error['error']['message']);
      alert(error['error']['message']);
      this.register_on_process = false;
    });
  }

  getExemployeeUnion() {
    this.http.getExEmployeeUnion().subscribe((data) => {
      console.info(data)
      this.icustomer_union_dict = data;
    })
  }
  // Method to handle the Customer Type change
  onCustomerTypeChange(selectedTypeId: number) {
    console.info(selectedTypeId);
    this.icustomer_register_form.get('customer_type_id').setValue(selectedTypeId);

    // Reset flags before updating
    this.showProductField = false;
    this.showExEmployeeUnionField = false;

    // Conditionally show/hide fields based on the customer type
    if (selectedTypeId == 2) {
      this.showProductField = true;
      this.showExEmployeeUnionField = true;
      // this.getproducts();
    }

    if (selectedTypeId == 3) {
      this.showProductField = true;
      this.showExEmployeeUnionField = true;
      // this.getExemployeeUnion();
    }
  }

  // check



  ngOnInit() {
  }

}

export interface CustomerType {
  id: number;
  name: string;
}

export interface BusinessList {
  id: number;
  name: string;
}

